module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submit.apply(null, arguments)
      }
    }
  }, [_c('md-input-container', {
    class: {
      'md-input-invalid': _vm.currentPasswordError
    }
  }, [_c('label', {
    attrs: {
      "for": "current-password-input"
    }
  }, [_vm._v("Current Password")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "id": "current-password-input",
      "type": _vm.showCurrentPassword ? 'text' : 'password',
      "required": ""
    },
    on: {
      "input": _vm.validateAll,
      "paste": _vm.validateAll
    },
    model: {
      value: (_vm.currentPassword),
      callback: function($$v) {
        _vm.currentPassword = $$v
      },
      expression: "currentPassword"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "toggle-password",
    on: {
      "click": function($event) {
        return _vm.toggleShowPassword('current')
      }
    }
  }, [_c('md-icon', [_vm._v(_vm._s(_vm.showCurrentPassword ? 'visibility' : 'visibility_off'))])], 1), _vm._v(" "), (_vm.currentPasswordError) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e()], 1), _vm._v(" "), _c('md-input-container', {
    class: {
      'md-input-invalid': _vm.newPasswordError
    }
  }, [_c('label', {
    attrs: {
      "for": "new-password-input"
    }
  }, [_vm._v("New Password")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "id": "new-password-input",
      "type": _vm.showNewPassword ? 'text' : 'password',
      "required": ""
    },
    on: {
      "input": _vm.validateAll,
      "paste": _vm.validateAll
    },
    model: {
      value: (_vm.newPassword),
      callback: function($$v) {
        _vm.newPassword = $$v
      },
      expression: "newPassword"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "toggle-password",
    on: {
      "click": function($event) {
        return _vm.toggleShowPassword('new')
      }
    }
  }, [_c('md-icon', [_vm._v(_vm._s(_vm.showNewPassword ? 'visibility' : 'visibility_off'))])], 1), _vm._v(" "), (_vm.newPasswordError) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v("\n        " + _vm._s(_vm.sameAsCurrentPassword ? 'New password cannot be the same as current password' : _vm.errorMessage) + "\n    ")]) : _vm._e()], 1), _vm._v(" "), _c('md-input-container', {
    class: {
      'md-input-invalid': _vm.confirmPasswordError
    }
  }, [_c('label', {
    attrs: {
      "for": "confirm-password-input"
    }
  }, [_vm._v("Re-Type Password")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "id": "confirm-password-input",
      "type": _vm.showConfirmPassword ? 'text' : 'password',
      "required": ""
    },
    on: {
      "input": _vm.validateAll,
      "paste": _vm.validateAll
    },
    model: {
      value: (_vm.confirmPassword),
      callback: function($$v) {
        _vm.confirmPassword = $$v
      },
      expression: "confirmPassword"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "toggle-password",
    on: {
      "click": function($event) {
        return _vm.toggleShowPassword('confirm')
      }
    }
  }, [_c('md-icon', [_vm._v(_vm._s(_vm.showConfirmPassword ? 'visibility' : 'visibility_off'))])], 1), _vm._v(" "), (_vm.confirmPasswordError) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v("Passwords do not match")]) : _vm._e()], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised",
    attrs: {
      "disabled": !_vm.isComplete || _vm.loading
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("\n    " + _vm._s(_vm.loading ? 'Submitting...' : 'Submit') + "\n    ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8b03112e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/change-password.vue
// module id = 1275
// module chunks = 21